import { Button, Text } from "@mantine/core";
import { modals } from "@mantine/modals";
import { notifications } from "@mantine/notifications";
import type { JSX } from "react";
import { useMutation } from "urql";
import {
    type TtsProjectDeleteMutation,
    type TtsProjectDeleteMutationVariables,
    ttsProjectDeleteMutation,
} from "./queries";

interface IProps {
    project: {
        id: number;
    };
    onDeleted?: () => void;
}

function DeleteButton({ project, onDeleted }: IProps): JSX.Element {
    const [deleteResult, executeDelete] = useMutation<TtsProjectDeleteMutation, TtsProjectDeleteMutationVariables>(
        ttsProjectDeleteMutation,
    );

    const doDelete = async () => {
        const result = await executeDelete({ id: project.id });
        if (result.error) {
            notifications.show({
                title: "Failed to delete TTS Project",
                message: result.error.message,
            });
        } else {
            notifications.show({
                title: "TTS Project deleted",
                message: "TTS Project deleted",
            });
            if (onDeleted) {
                onDeleted();
            }
        }
    };

    const onClick = () =>
        modals.openConfirmModal({
            title: "Delete TTS Project?",
            children: <Text size="sm">Are you sure you want to delete this TTS project?</Text>,
            labels: { confirm: "Confirm", cancel: "Cancel" },
            onConfirm: doDelete,
            confirmProps: { color: "red" },
        });

    return (
        <Button onClick={onClick} disabled={deleteResult.fetching} color="red">
            Delete
        </Button>
    );
}

export default DeleteButton;
